import { render, staticRenderFns } from "./fiyatsizVoucher.vue?vue&type=template&id=c660b372&scoped=true"
import script from "./fiyatsizVoucher.vue?vue&type=script&lang=js"
export * from "./fiyatsizVoucher.vue?vue&type=script&lang=js"
import style0 from "./fiyatsizVoucher.vue?vue&type=style&index=0&id=c660b372&prod&scoped=true&lang=scss"
import style1 from "./fiyatsizVoucher.vue?vue&type=style&index=1&id=c660b372&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c660b372",
  null
  
)

export default component.exports